import { render, staticRenderFns } from "./TrainingDialogTabsSlider.vue?vue&type=template&id=726c0e0c&"
import script from "./TrainingDialogTabsSlider.vue?vue&type=script&lang=js&"
export * from "./TrainingDialogTabsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports